import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiMenuItem(theme: Theme): MuiThemeComponentOverride<"MuiMenuItem"> {
  return {
    MuiMenuItem: {
      defaultProps: {
        focusVisibleClassName: "MuiMenuItem-focus-visible",
      },
      styleOverrides: {
        root: {
          ["&.MuiMenuItem-focus-visible"]: {
            backgroundColor: theme.palette.brand.blue[100].lighter,
          },

          "&:hover": {
            backgroundColor: theme.palette.brand.blue[100].lighter,
          },
          color: theme.palette.brand.blue[500].main,
          margin: "0 -0.5rem",

          minHeight: "32px",
        },
      },
    },
  };
}
